import React, { FC, useState, useEffect, useCallback, useMemo } from 'react'

import { Grid, Button, Container, Card, Divider, Popup, List, Image, Segment } from 'semantic-ui-react'

import { themes } from '@/theme/context'
import { CustomCardGroup, CustomImage, FlexBlock, Link } from '@/components/OtherCustomComponents/style'

import { FullWidthBackgroundContainer, ThemedText, BodySegment, BodyContainer, PopupSegment, LeftBorderedSegment, IconsWrapper, ThemedCard } from './style'

export const BodyComponent = ({ drupalHost, currentAct }) => {
    const [active, setActive] = useState<number | undefined>()
    let leaveTimer

    const handleLeave = function () {
        leaveTimer = setTimeout(() => {
            setActive(undefined)
        }, 500);
    }
    const handleEnter = function (index) {
        clearTimeout(leaveTimer)
        setActive(index)
    }

    return (<BodyContainer>
        <FullWidthBackgroundContainer>
            <Container>
                <CustomCardGroup itemsPerRow={2} stackable>
                    <Card>
                        <Card.Content>
                            <FlexBlock>
                                <Image spaced="right" src="/themes/fepo/images/fepo10.svg" />
                                <b>ФЭПО</b>
                            </FlexBlock>
                            <p>Отражает результат освоения образовательной программы студентами на&nbsp;разных этапах обучения</p>
                        </Card.Content>
                    </Card>
                    <Card>
                        <Card.Content>
                            <FlexBlock>
                                <Image spaced="right" src="/themes/fepo/images/fepo11.svg" />
                                <b>ФЭПО-pro</b>
                            </FlexBlock>
                            <p>Позволяет оценить уровень фундаментальной подготовки студентов по&nbsp;окончании второго курса</p>
                        </Card.Content>
                    </Card>
                </CustomCardGroup>
            </Container>
        </FullWidthBackgroundContainer>
        <Container>
            <p>Оценка качества подготовки обучающихся, проведенная с&nbsp;помощью сервиса «{themes[currentAct].title}», может быть определена как вид внутренней системы оценки качества образования (<Link href="/node/1668">ВСОКО</Link>) и зачтена при&nbsp;прохождении государственных аккредитационных процедур контроля.</p>
            <BodySegment>
                <p>ФЭПО предусматривает проведение тестирования студентов <ThemedText><Link href="/fgos_pim_struct">по&nbsp;дисциплинам</Link></ThemedText> высшего и среднего профессионального образования, а также по&nbsp;дисциплинам <ThemedText><Link href="/node/927">общеобразовательного цикла</Link></ThemedText>  (для&nbsp;обучающихся по&nbsp;профессиям и/или специальностям СПО на&nbsp;базе 9 классов).</p>
                <p>Используемые педагогические измерительные материалы (ПИМ) <ThemedText><Link href="/node/1413">сертифицированы.</Link></ThemedText></p>
                <p>Система тестирования отличается широким разнообразием представленных в&nbsp;сервисах портала <ThemedText><Link href={`//test.${drupalHost}/demo/training/student/index.html?alltypes`}>типов заданий</Link></ThemedText>, позволяющих эффективно оценивать образовательные достижения студентов.</p>
            </BodySegment>
        </Container>
        <Container>
            <p><ThemedText><b>Модель ПИМ</b></ThemedText></p>
            <p>В&nbsp;рамках ФЭПО используется <b>уровневая модель</b> педагогических измерительных материалов, представленная в&nbsp;трех взаимосвязанных блоках.</p>
            <Grid stackable>
                <Grid.Row columns={3}>
                    <Grid.Column textAlign="center">
                        <div onMouseEnter={() => handleEnter(1)} onMouseLeave={handleLeave}>
                            <CustomImage src="/themes/fepo/images/fepo6.svg" centered $height="60px" />
                            <i>Первый блок</i> — задания <br /> <b>на&nbsp;уровне «знать»</b>
                        </div>
                    </Grid.Column>
                    <Grid.Column textAlign="center">
                        <div onMouseEnter={() => handleEnter(2)} onMouseLeave={handleLeave}>
                            <CustomImage src="/themes/fepo/images/fepo9.svg" centered $height="60px" />
                            <i>Второй блок</i> — задания<br /> <b>на&nbsp;уровне «знать» и «уметь»</b>
                        </div>
                    </Grid.Column>
                    <Grid.Column textAlign="center">
                        <div onMouseEnter={() => handleEnter(3)} onMouseLeave={handleLeave}>
                            <CustomImage src="/themes/fepo/images/fepo5.svg" centered $height="60px" />
                            <i>Третий блок</i> — задания<br/> <b>на&nbsp;уровне «знать», «уметь», «владеть»</b>
                        </div>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
            {active === 1 && <PopupSegment $position={active} onMouseEnter={() => handleEnter(1)} onMouseLeave={() => setActive(undefined)}>
                <i>Очевиден способ решения, усвоенный студентом при&nbsp;изучении дисциплины. Задания этого блока выявляют в&nbsp;основном знаниевый компонент по&nbsp;дисциплине и оцениваются по&nbsp;бинарной шкале «правильно-неправильно».</i>
            </PopupSegment>}
            {active === 2 && <PopupSegment $position={active} onMouseEnter={() => handleEnter(2)} onMouseLeave={() => setActive(undefined)}>
                <i>В&nbsp;них нет явного указания на&nbsp;способ выполнения, и студент для&nbsp;их решения самостоятельно выбирает один из&nbsp;изученных способов. Задания данного блока позволяют оценить не только знания по&nbsp;дисциплине, но и умения пользоваться ими при&nbsp;решении стандартных, типовых задач. Результаты выполнения этого блока оцениваются с&nbsp;учетом частично правильно выполненных заданий.</i>
            </PopupSegment>}
            {active === 3 && <PopupSegment $position={active} onMouseEnter={() => handleEnter(3)} onMouseLeave={() => setActive(undefined)}>
                <i>Представлен кейс-заданиями, содержание которых предполагает использование комплекса умений и навыков, для&nbsp;того чтобы студент мог самостоятельно сконструировать способ решения, комбинируя известные ему способы и привлекая знания из&nbsp;разных дисциплин. Кейс-задание представляет собой учебное задание, состоящее из&nbsp;описания реальной практической ситуации и совокупности сформулированных к&nbsp;ней вопросов. Выполнение студентом кейс-заданий требует решения поставленной проблемы (ситуации) в&nbsp;целом и проявления умения анализировать конкретную информацию, прослеживать причинно-следственные связи, выделять ключевые проблемы и методы их решения. В&nbsp;отличие от&nbsp;первых двух блоков задания третьего блока носят интегральный (summative) характер и позволяют формировать нетрадиционный способ мышления, характерный и необходимый для&nbsp;современного человека.<br/>
                Решение студентами подобного рода нестандартных практико-ориентированных заданий свидетельствует о&nbsp;степени влияния процесса изучения дисциплины на&nbsp;формирование у&nbsp;студентов универсальных и профессиональных компетенций в&nbsp;соответствии с&nbsp;требованиями ФГОС. </i>
            </PopupSegment>}
            <br/>
            <p>Преподаватель может самостоятельно сформировать структуру педагогических измерительных материалов в&nbsp;соответствии с&nbsp;содержанием рабочих программ.</p>
        </Container>
        <Container>
            <p><Link href="/node/156">Алгоритм и пример оценки результатов</Link></p>
        </Container>
        <FullWidthBackgroundContainer>
            <Container>
                <Grid stackable>
                    <Grid.Row>
                        <Grid.Column width={10}>
                            <p><ThemedText><b>Сертификаты качества</b></ThemedText></p>
                            <p>Образовательным организациям по&nbsp;итогам успешного прохождения независимой оценки качества образования предоставляются <b>сертификаты качества.</b></p>
                        </Grid.Column>
                        <Grid.Column width={6}>
                            <IconsWrapper>
                                <Popup
                                    content={<>Учитываются при процедуре профессионально-общественной аккредитации</>}
                                    trigger={<Image src="/themes/fepo/images/fepo14.png?new" floated="left" size='tiny'/>}
                                    hideOnScroll={true}
                                    style={{ fontSize: '18px' }}
                                    hoverable={true}

                                />
                                <Popup
                                    content={<>Учитываются в проекте <ThemedText><Link target="_blank" href="//expert-edu.ru/services/proekt-luchshie-obrazovatelnye-programmy-innovatsionnoj-rossii.html">«Лучшие образовательные программы инновационной России» (Решение Национального аккредитационного совета от 30.09.2013 г.).</Link></ThemedText></>}
                                    trigger={<Image src="/themes/fepo/images/fepo2.png" floated="right" size='tiny'/>}
                                    hideOnScroll={true}
                                    style={{ fontSize: '18px' }}
                                    hoverable={true}
                                />
                                <Popup
                                    content={<>Учитываются в <ThemedText><Link target="_blank" href="//best-edu.ru/ratings/national/rejting-ocenka-kachestva-obrazovaniya">Национальном агрегированном рейтинге.</Link></ThemedText></>}
                                    trigger={<CustomImage src="/themes/fepo/images/fepo13.png" centered size='tiny' $margin='50px auto auto auto' />}
                                    hideOnScroll={true}
                                    style={{ fontSize: '18px' }}
                                    size="huge"
                                    wide={true}
                                    hoverable={true}
                                />
                            </IconsWrapper>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <br/>
                <p>Критерии для&nbsp;включения направления подготовки в&nbsp;сертификат качества </p>
                <Grid stackable>
                    <Grid.Row columns={3}>
                        <Grid.Column>
                            <LeftBorderedSegment>
                                выборка студентов по&nbsp;направлению подготовки составляет <b>не менее 10 человек</b>
                            </LeftBorderedSegment>
                        </Grid.Column>
                        <Grid.Column>
                            <LeftBorderedSegment>
                                тестирование не менее чем <b>по&nbsp;трем дисциплинам</b>
                            </LeftBorderedSegment>
                        </Grid.Column>
                        <Grid.Column>
                            <LeftBorderedSegment>
                                <b>не менее 60%</b> результатов студентов <b>соответствует</b> уровню обученности <b>не ниже второго</b>
                            </LeftBorderedSegment>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <br/>
                <p><Link href="/node/517">Пример анализа результатов согласно критериям</Link></p>
            </Container>
        </FullWidthBackgroundContainer>
        <Container>
            <p>Успешное участие в&nbsp;ФЭПО позволяет образовательным организациям, реализующим программы <b>СПО</b>, получить <b>два</b> сертификата качества.<br /></p>
            <Grid stackable>
                <Grid.Row>
                    <Grid.Column width={3}>
                        <Image centered size="small" src="/themes/fepo/images/fepo3.png" />
                    </Grid.Column>
                    <Grid.Column width={5} verticalAlign="middle">
                        Сертификат качества по&nbsp;итогам
                        тестирования<b> только
                        по&nbsp;дисциплинам среднего
                        профессионального образования</b>
                    </Grid.Column>
                    <Grid.Column width={3}>
                        <Image centered size="small" src="/themes/fepo/images/fepo4.png" />
                    </Grid.Column>
                    <Grid.Column width={5} verticalAlign="middle">
                        Сертификат качества
                        по&nbsp;итогам тестирования<b> только
                        по&nbsp;дисциплинам
                        общеобразовательного цикла</b>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </Container>
        <Container>
            <Segment>
                <Grid stackable>
                    <Grid.Row>
                        <Grid.Column width={13}>
                            <ThemedText><b>Педагогический анализ</b></ThemedText><br /> содержит количественные показатели участия в&nbsp;ФЭПО, сравнительную оценку результатов обучения образовательной организации и вузов-участников, мониторинг результатов тестирования студентов по&nbsp;дисциплинам, отдельным направлениям подготовки и специальностям.
                        </Grid.Column>
                        <Grid.Column width={3}>
                            <Image src="/themes/fepo/images/fepo1.png" />
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <br/>
                <Card.Group itemsPerRow={3} stackable>
                    <ThemedCard>
                        <Card.Content textAlign="center">
                            <ThemedText><Link href="/sites/default/files/otchet_po_vuzu.pdf">по&nbsp;вузу/ссузу (филиалу) в&nbsp;целом</Link></ThemedText> (для&nbsp;ректората/директората)
                        </Card.Content>
                    </ThemedCard>
                    <ThemedCard>
                        <Card.Content textAlign="center">
                            <ThemedText><Link href="/sites/default/files/otchet_po_obr_progr.pdf">по&nbsp;каждой образовательной программе</Link></ThemedText> (для&nbsp;деканов и заведующих выпускающими кафедрами)
                        </Card.Content>
                    </ThemedCard>
                    <ThemedCard>
                        <Card.Content textAlign="center">
                            <ThemedText><Link href="/sites/default/files/otchet_po_discipline.pdf">по&nbsp;каждой дисциплине</Link></ThemedText> (для&nbsp;заведующих кафедрами и преподавателей)
                        </Card.Content>
                    </ThemedCard>
                </Card.Group>
            </Segment>
        </Container>
    </BodyContainer>)
}